import React, { createContext, useState, useContext } from "react";
export const RouteContext = createContext();

// eslint-disable-next-line react/prop-types
export default function UserRoute({ children }) {
  const [route, setRoute] = useState(sessionStorage.getItem("route") ?? "/");

  return (
    <RouteContext.Provider value={{ route, setRoute }}>
      {children}
    </RouteContext.Provider>
  );
}
export function useRoute() {
  return useContext(RouteContext);
}
